import React from 'react';
import Helmet from "react-helmet";
import DiscountInclude from '../../components/includes/discountInclude';
import PaymentMethodsInclude from '../../components/includes/paymentMethodsInclude';
import FeatureSlider from './featureSlider';
import ReactDependentScript from "react-dependent-script";
import DiscountCounter from './dscountCounter';
import AboutCMS from './aboutCMS';
import FreeSSL from './freeSSL'
import FreeSpeechInSwitzerland from '../free-speech-hosting/freeSpeechInSwitzerland';

class CMSfreeSpeech extends React.Component {

	render() {

		const cms = 'all'

		return (
			<React.Fragment>
				<Helmet>
					<title>Free Speech CMS Hosting - Dedicated IP &amp; Private Server | Swiss Made Host</title>
					<meta name="description" content="Freedom of Speech inspired Content Management System Hosting with dedicated resources and IP address. Powered by WordPress, Joomla and Drupal." />
					<link rel="canonical" href="https://swissmade.host/en/free-speech-cms-hosting" />
				</Helmet>
				<div className="fullwidth pic cms">
					<div className="row">
						<div className="twelve columns">
							<div className="transparent">
								<h1 className="title">Free Speech <span>CMS Hosting</span></h1>
								<h2>Freedom of Speech Safe Harbor powered by WordPress, Drupal and Joomla</h2>
							</div>
						</div>
					</div>
				</div>
				<DiscountInclude />
				<FreeSpeechInSwitzerland />
				<AboutCMS cms={cms}/>
				<ReactDependentScript scripts={["/js/jquery-3.4.1.js"]}>
					<FeatureSlider />
				</ReactDependentScript>
				<DiscountCounter cms={cms}/>
				<FreeSSL cms={cms}/>
				<PaymentMethodsInclude />
			</React.Fragment>
		)
	}
	toggleAnimation = (e) => {
		document.getElementById('ddos-protection-info').classList.toggle('expanded')
	}
}

export default CMSfreeSpeech;